module.exports = (flex = window.flex) => {

    class TrackedComponent {
        constructor({ fields = [], prefix = '' }) {
            this.fields = fields;
            this.prefix = prefix;
        }

        trackedValues(source) {
            return this.fields.reduce((reduction, field) => {
                // Get alias
                let key = field.split(':'),
                    keyAlias = key.length > 1 ? key[1] : key[0];
                key = key[0];

                key = key.split('.');
                let value = flex.resolveObjectPath(source, ...key);

                if (!!value) {
                    let trackedKey = `${keyAlias}`;
                    if (this.prefix.length) {
                        trackedKey = `${this.prefix}:${trackedKey}`;
                    }
                    reduction[trackedKey] = value;
                }

                return reduction;
            }, {});
        }
    }

    return TrackedComponent;
};